import { render, staticRenderFns } from "./SetRingCentralGroupChatLastMessageDatesModal.vue?vue&type=template&id=2f806e60&scoped=true&"
import script from "./SetRingCentralGroupChatLastMessageDatesModal.vue?vue&type=script&lang=js&"
export * from "./SetRingCentralGroupChatLastMessageDatesModal.vue?vue&type=script&lang=js&"
import style0 from "./SetRingCentralGroupChatLastMessageDatesModal.vue?vue&type=style&index=0&id=2f806e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f806e60",
  null
  
)

export default component.exports